import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../../../../store/marketing/publicador/MarketingPublicadorConfig';

import Formsy from 'formsy-react';
import { Row, Modal } from 'react-bootstrap';
import ProgerssBar from '../../../../commons/ProgressBar';
import AlertError from '../../../../commons/AlertError';
import AlertSuccess from '../../../../commons/AlertSuccess';
import InputTextValidated from '../../../../commons/InputTextValidated';
import BtnSalvar from '../../../../commons/BtnSalvar';
import BtnCancelar from '../../../../commons/BtnCancelar';

class ModalTemUsados extends React.Component {
    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async componentDidMount() {
        if (this.props.configuracaoPortais.modalPortais.modalTemUsados.showModal) {
            if (this.props.configuracaoPortais.modalPortais.ativado) {
                await this.props.fnBuscaConfiguracaoPortal();
                this.props.configuracaoPortais.modalPortais.modalTemUsados.id_anunciante = JSON.parse(this.props.configuracaoPortais.modalPortais.jsAutenticacao).id_anunciante;
                this.props.configuracaoPortais.modalPortais.modalTemUsados.login = JSON.parse(this.props.configuracaoPortais.modalPortais.jsAutenticacao).login;
                this.props.configuracaoPortais.modalPortais.modalTemUsados.senha = JSON.parse(this.props.configuracaoPortais.modalPortais.jsAutenticacao).senha;
                this.props.fnUpdateState(this.props);
            }
            else {
                this.props.configuracaoPortais.modalPortais.modalTemUsados.id_anunciante = 0;
                this.props.configuracaoPortais.modalPortais.modalTemUsados.login = '';
                this.props.configuracaoPortais.modalPortais.modalTemUsados.senha = '';
                this.props.fnUpdateState(this.props);
            }
        }
    }

    async handleSubmit(e) {
        var autenticacao = {
            id_anunciante: this.props.configuracaoPortais.modalPortais.modalTemUsados.id_anunciante,
            login: this.props.configuracaoPortais.modalPortais.modalTemUsados.login,
            senha: this.props.configuracaoPortais.modalPortais.modalTemUsados.senha
        };

        if (this.props.configuracaoPortais.modalPortais.ativado) {
            await this.props.fnAtualizaConfiguracaoPortal(JSON.stringify(autenticacao), '');
            this.props.configuracaoPortais.modalPortais.modalTemUsados.showModal = false;
        }
        else {
            await this.props.fnInsereConfiguracaoPortal(JSON.stringify(autenticacao), '');
            this.props.configuracaoPortais.modalPortais.modalTemUsados.showModal = false;
        }
    }

    handleOnHide() {
        this.props.configuracaoPortais.modalPortais.modalTemUsados.showModal = false;
        this.props.fnUpdateState(this.props);
    }

    render() {
        return <Modal
            show={this.props.configuracaoPortais.modalPortais.modalTemUsados.showModal}
            onHide={this.handleOnHide.bind(this)}
        >
            <Formsy onValidSubmit={this.handleSubmit}>
                <Modal.Header closeButton>
                    <h4 className="modal-title custom-font">Configurar Tem Usados</h4>
                </Modal.Header>
                <Modal.Body>
                    <AlertSuccess
                        successText={this.props.configuracaoPortais.modalPortais.successText}
                        alertVisible={this.props.configuracaoPortais.modalPortais.successText != '' && this.props.configuracaoPortais.modalPortais.successText != undefined ? true : false}
                        onDismiss={(alertVisible, successText) => {
                            this.props.configuracaoPortais.modalPortais.successText = successText;
                            this.props.fnUpdateState(this.props);
                        }}
                    />
                    <AlertError
                        errorText={this.props.configuracaoPortais.modalPortais.errorText}
                        alertVisible={this.props.configuracaoPortais.modalPortais.errorText != '' && this.props.configuracaoPortais.modalPortais.errorText != undefined ? true : false}
                        onDismiss={(alertVisible, errorText) => {
                            this.props.configuracaoPortais.modalPortais.errorText = errorText;
                            this.props.fnUpdateState(this.props);
                        }}
                    />
                    {
                        this.props.configuracaoPortais.modalPortais.isLoading
                            ? <ProgerssBar />
                            : <Row>
                                <InputTextValidated
                                    name="txtIdAnunciante"
                                    type="number"
                                    className="col-md-12"
                                    placeholder="Informe o login"
                                    onChange={(name, value) => {
                                        this.props.configuracaoPortais.modalPortais.modalTemUsados.id_anunciante = parseInt(value);
                                        this.props.fnUpdateState(this.props);
                                    }}
                                    value={this.props.configuracaoPortais.modalPortais.modalTemUsados.id_anunciante.toString()}
                                    title="ID do anunciante:"
                                    required
                                />
                                <InputTextValidated
                                    name="txtEmail"
                                    type="text"
                                    className="col-md-12"
                                    placeholder="Informe o login"
                                    onChange={(name, value) => {
                                        this.props.configuracaoPortais.modalPortais.modalTemUsados.login = value;
                                        this.props.fnUpdateState(this.props);
                                    }}
                                    value={this.props.configuracaoPortais.modalPortais.modalTemUsados.login}
                                    title="Email:"
                                    validations="isEmail"
                                    validationError="Informe um email válido"
                                    required
                                />
                                <InputTextValidated
                                    name="txtSenha"
                                    type="text"
                                    className="col-md-12"
                                    placeholder="Informe a senha"
                                    onChange={(name, value) => {
                                        this.props.configuracaoPortais.modalPortais.modalTemUsados.senha = value;
                                        this.props.fnUpdateState(this.props);
                                    }}
                                    value={this.props.configuracaoPortais.modalPortais.modalTemUsados.senha}
                                    title="Senha:"
                                    required
                                />
                            </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {this.props.configuracaoPortais.modalPortais.ativado == true
                        ? <BtnCancelar
                            type="button"
                            text=" Remover Portal"
                            textLoading=" Aguarde..."
                            isLoading={this.props.configuracaoPortais.modalPortais.isLoading}
                            onClick={async () => {
                                await this.props.fnDeleteConfiguracaoPortal();
                                this.props.configuracaoPortais.modalPortais.modalTemUsados.showModal = false;
                                this.props.fnUpdateState(this.props);
                            }}
                        />
                        : null}
                    <BtnSalvar
                        type="submit"
                        text={this.props.configuracaoPortais.modalPortais.ativado == false ? " Salvar Configuração" : " Alterar Configuração"}
                        textLoading=" Aguarde..."
                        isLoading={this.props.configuracaoPortais.modalPortais.isLoading}
                    />
                </Modal.Footer>
            </Formsy>
        </Modal>;
    }
}

export default connect(
    state => state.marketing_publicadorconfig,
    dispatch => bindActionCreators(actionCreators, dispatch),
    null, {}
)(ModalTemUsados);